@if (links?.length > 0) {
  <sd-navigation-account [links]="links" (clicked)="onClicked($event)" />
}
